module.exports = __webpack_public_path__ + "img/w3_trash_black.7a38d4ac.7a38d4ac.png";